<app-generic-login [loginImpl]="this"></app-generic-login>
